import { CorrespondenceMethodEnum, CountryCodeEnum } from '../../../types/forms';
import { CustomerDetailsFormModel_PL } from './formModel';

export const getInitialValues = (): CustomerDetailsFormModel_PL => {
  return {
    title: undefined,
    gender: undefined,
    maritalStatus: undefined,
    firstName: undefined,
    lastName: undefined,
    middleName: undefined,
    maidenName: undefined,
    dateOfBirth: undefined,
    email: undefined,
    countryCode: CountryCodeEnum.Ireland,
    phoneNumber: undefined,
    correspondenceMethod: CorrespondenceMethodEnum.email,
    nationality: undefined,
  };
};
